export function getCleanPathname(pathname: string) {
  const withoutTrailingSlash = pathname.replace(/\/$/, "") || "/"
  const withLeadingSlash = withoutTrailingSlash.startsWith("/")
    ? withoutTrailingSlash
    : `/${withoutTrailingSlash}`

  return withLeadingSlash
}
